export function hasValue<T>(value: T): value is NonNullable<T> {
  // oxlint-disable-next-line custom/no-nullish-comparison
  return value !== null && value !== undefined;
}

export function isNullish<T>(value: T): value is Extract<T, null | undefined> {
  // oxlint-disable-next-line custom/no-nullish-comparison
  return value === null || value === undefined;
}

export function requireValue<T>(value: T): NonNullable<T> {
  if (hasValue(value)) {
    return value;
  }

  throw new Error("Required value is missing");
}
